import { render, staticRenderFns } from "./CardTestimonial.vue?vue&type=template&id=317c7081&scoped=true&"
import script from "./CardTestimonial.vue?vue&type=script&lang=js&"
export * from "./CardTestimonial.vue?vue&type=script&lang=js&"
import style0 from "./CardTestimonial.vue?vue&type=style&index=0&id=317c7081&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "317c7081",
  null
  
)

export default component.exports